import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "binFilled"
const BinFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C12.995 1.5 13.948 1.895 14.651 2.599 15.175 3.122 15.528 3.785 15.674 4.5H18.62Q18.686 4.5 18.75 4.507V4.5H21.75C21.75 5.328 21.078 6 20.25 6H20.118Q20.118 6.062 20.115 6.125L18.865 21.125Q18.848 21.299 18.794 21.46 18.786 21.492 18.775 21.524L18.75 21.582Q18.736 21.617 18.72 21.65 18.707 21.68 18.69 21.707L18.656 21.77 18.625 21.818 18.585 21.878 18.537 21.938 18.506 21.978 18.456 22.032 18.406 22.083 18.365 22.12Q18.335 22.146 18.304 22.17L18.264 22.203 18.194 22.252 18.154 22.277Q18.115 22.301 18.075 22.323L18.037 22.343 17.958 22.378 17.912 22.398 17.822 22.429 17.787 22.441Q17.654 22.479 17.514 22.493L17.37 22.5H6.63Q6.56 22.5 6.49 22.493 6.454 22.49 6.417 22.483L6.356 22.474Q6.315 22.466 6.272 22.455L6.226 22.444 6.153 22.42 6.094 22.4 6.03 22.372 5.97 22.346 5.916 22.316Q5.886 22.303 5.855 22.284L5.796 22.245 5.746 22.21 5.691 22.17 5.636 22.12 5.597 22.086 5.545 22.034 5.5 21.984 5.462 21.94 5.413 21.876 5.388 21.838 5.344 21.773 5.303 21.697 5.283 21.659Q5.267 21.625 5.253 21.59 5.156 21.373 5.134 21.125L3.885 6.125Q3.882 6.062 3.882 6H3.75C2.922 6 2.25 5.328 2.25 4.5H5.25V4.507Q5.314 4.5 5.38 4.5H8.326C8.472 3.785 8.825 3.122 9.35 2.599 10.052 1.895 11.005 1.5 12 1.5M9 17.25H10.5V9.75H9zM13.5 9.75V17.25H15V9.75zM12 3C11.403 3 10.831 3.237 10.41 3.66 10.17 3.897 9.992 4.186 9.881 4.5H14.118C14.008 4.187 13.83 3.898 13.591 3.66 13.169 3.236 12.597 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BinFilledIcon
